import './SimpleFormWrapper.less';

interface SimpleFormWrapperProps {
	className?: string;
}

export const SimpleFormWrapper: React.FC<SimpleFormWrapperProps> = ({
	children,
	className,
}) => {
	const cls = 'form-wrapper' + (className ? ' ' + className : '');
	return <div className={cls}>{children}</div>;
};
